import React, { useEffect } from 'react'

const useSocketEvents = (socket, eventHandlers={}) => {
  useEffect(() => {
    if(!socket) return;

    for (const [event, handler] of Object.entries(eventHandlers)) {
      socket.on(event, handler);
    }

    return () => {
        for (const [event, handler] of Object.entries(eventHandlers)) {
          socket.off(event, handler);
        }
    }
  }, [socket, eventHandlers])

  return (
    <div>useSocketEvents</div>
  )
}

export default useSocketEvents